module.exports = __webpack_public_path__ + "static/media/shop.f3a56f67.png";